<button
	class="btn btn-primary"
	(click)="openConfigurationData()">show <i class="pi pi-external-link"></i></button>
